/**
 * Version 0.0.0
 *
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var template = require('registration-templates/plan-selection/planSelectionView.tmpl');
    
    var Button = require("ui/button/Button");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var BillingManager = require("registration-controllers/BillingManager");

    // VIEWS
    var PlanView = require("registration-views/plan-selection/PlanView");

    // COLLECTION
    var BaseCollection = require("collections/BaseCollection");
    var PlansCollection = require('registration-collections/PlansCollection');

    var PlanSelectionView = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        PlanSelectionView = Marionette.CompositeView.extend({
            template: template,
            className: 'plan-selection-view',
            itemView: PlanView,
            itemViewContainer: ".plans-row-container .plans-carousel",

            withUIComponents: true,
            ui: {
                nextBtn: ".button-next",
                cancelBtn: ".button-cancel",
                stepIndicator: ".step-indicator",
                plansView: ".view-container",
                tabs: ".tabs-period span",
                chatBtn: ".chat-with-us",
                engagementsUsageContainer: ".engagements-usage-container",
                numOfEngagements: ".engagements-usage-num",
                nonCatalogPersonalPlan: ".noncatalog-personal-plan-container .plan-box",
                billingCycleBar: ".billing-period-container",
                plansRowContainer: ".plans-row-container",
                plansCarouselStepIndicator: ".plans-carousel-stepIndicator"
            },
            events: {
                "click .tabs-period span": "_onSwitchPeriod",
                "click .chat-with-us": "_onChat",
                "click .learn-more": "_onLearnMore",
                "click .plans-carousel-buttons > div": "_onPlansNav"
            },
            uiComponents: {
                nextBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.nextBtn",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.DISABLED
                    }
                },
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelBtn",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onClosePage"
                    }
                },
                stepIndicator: {
                    type: StepIndicator,
                    options: "stepIndicatorOptions"
                }
            },

            initialize: function(options){
                LERegistration.logger.info("view initialize", "PlanSelectionView:initialize");
                this.mode= options.mode;
                this.parseTemplateHelpers();
                this.controller= options.controller;
                this.listenTo(this, "page:closeButtonClick", this._onClosePage);
                this.listenTo(this.controller.billingManager, BillingManager.TRIGGERING.CHANGED_CREDITS_USAGE, _.bind(this._updateNumOfEngagements,this));

            },
            parseTemplateHelpers: function(){
                var parsed= {};

                //TRIAL or PAYING
                parsed.mode= this.mode.toLowerCase(); 
                
                // handle number of engagements
                if ( this.model.get("engagementUsage") > -1 ) {
                    parsed.engagementsUsageNum= this.model.get("engagementUsage");
                } else {
                    parsed.engagementsUsageVisibility= "hide";
                }

                // show cycle annual|quarter
                var selectedPlan = this.collection.findWhere({"planType": PlansCollection.TYPES.CURRENT});
                parsed.hasSelectedPlan = selectedPlan !== undefined;

                // has plans in cycle
                parsed.hasYearlyPlans= hasPlansInCycle(this.collection, 12);
                parsed.hasQuarterlyPlans= hasPlansInCycle(this.collection, 3);
                parsed.hasMonthlyPlans= hasPlansInCycle(this.collection, 1);

                var selectedCycleInMonths = selectedPlan ? selectedPlan.get("baseBillingFrequencyMonths") : 0;
                parsed.isAnnualTabSelected = selectedCycleInMonths === 12;
                parsed.isQuarterTabSelected = selectedCycleInMonths === 3;
                parsed.isMonthTabSelected = selectedCycleInMonths === 1;
                parsed.selectedTab = parsed.isAnnualTabSelected ? "annual" : (parsed.isQuarterTabSelected ? "quarter" : (parsed.isMonthTabSelected ? "month" : ""));

                if(parsed.selectedTab === ""){
                    parsed.selectedTab = parsed.hasYearlyPlans ? "annual" : (parsed.hasQuarterlyPlans ? "quarter" : (parsed.hasMonthlyPlans ? "month" : ""));
                    switch(parsed.selectedTab){
                        case "annual":
                            parsed.isAnnualTabSelected = true;
                            break;
                        case "quarter":
                            parsed.isQuarterTabSelected = true;
                            break;
                        case "month":
                            parsed.isMonthTabSelected = true;
                            break;
                    }
                }

                // has personal offer(to hide recommended banner)
                var personalPlan= this.model.get("collection").findWhere({"planType": PlansCollection.TYPES.PERSONAL});
                if(personalPlan){
                    parsed.personalPeriod=  personalPlan.get("baseBillingFrequencyMonths") === 12 ? "personal-annual" : (personalPlan.get("baseBillingFrequencyMonths") === 3 ? "personal-quarter" : "personal-month");
                }

                // .personal-in-catalog 
                var catalogPersonal= this.model.get("collection").findWhere({"isCatalogPersonal": true});
                if(catalogPersonal){
                    parsed.personalMode= "personal-in-catalog";
                }else{
                    parsed.personalMode= personalPlan ? "personal-not-in-catalog" : "no-personal";
                    parsed.personalPlan= personalPlan;
                }

                var cycleOfPersonalToInclude= parsed.personalMode === "personal-in-catalog" ? personalPlan.get("baseBillingFrequencyMonths") : 0;
                groupPlans(this, cycleOfPersonalToInclude, selectedCycleInMonths);

                parsed.allPlansMode= true;

                this.model.set('parsed', parsed);
                LERegistration.logger.debug("PlanSelectionView parsed model", "PlanSelectionView:parseTemplateHelpers", parsed);

                function hasPlansInCycle(collection, cycleInMonths){
                    var plans= collection.where({"baseBillingFrequencyMonths": cycleInMonths});
                    return plans.length > 0;
                }
                /**
                 * group model example: {"annual":{"offset":0,"count":3},"quarter":{"offset":0,"count":0},"month":{"offset":0,"count":3}}
                 */
                function groupPlans(that, cycleOfPersonalToInclude, cycleOfCurrentToInclude){
                    var groups= {
                        annual: {offset: 0},
                        quarter: {offset: 0},
                        month: {offset: 0}
                    };

                    groups.annual.count= that.collection.where({
                        "planType": PlansCollection.TYPES.CATALOG,
                        "baseBillingFrequencyMonths": 12
                    }).length + (cycleOfPersonalToInclude === 12 ? 1 : 0) + (cycleOfCurrentToInclude === 12 ? 1 : 0);

                    groups.quarter.count= that.collection.where({
                        "planType": PlansCollection.TYPES.CATALOG,
                        "baseBillingFrequencyMonths": 3
                    }).length + (cycleOfPersonalToInclude === 3 ? 1 : 0) + (cycleOfCurrentToInclude === 3 ? 1 : 0);

                    groups.month.count= that.collection.where({
                        "planType": PlansCollection.TYPES.CATALOG,
                        "baseBillingFrequencyMonths": 1
                    }).length + (cycleOfPersonalToInclude === 1 ? 1 : 0) + (cycleOfCurrentToInclude === 1 ? 1 : 0);

                    LERegistration.logger.info(JSON.stringify(groups));
                    
                    that.groups= groups;
                }
            },
            onRender: function () {
                if(this.model.get("parsed.personalPlan") && !this.personalMode){
                    this.personalPlanView= new PlanView({model: this.model.get("parsed.personalPlan"), el: this.ui.nonCatalogPersonalPlan});
                    this.personalPlanView.render();
                    $(this.ui.plansRowContainer).prepend($(this.ui.billingCycleBar));
                }
            },
            onShow: function () {
                _.delay(_.bind(function(){
                    this._updateCarouselNavBtnVisibility();
                    //update the number of steps to turn on, either 2 or 3 depending on the 
                    //width available. would either be 795 or 535 pixels
                    var numOfVisiblePlans= $(this.ui.plansRowContainer).width() > 700 ? 3 : 2;
                    $(window).resize( _.bind(function(){
                        var newNumOfVisiblePlans= $(this.ui.plansRowContainer).width() > 700 ? 3 : 2;
                        // resize events are continuosly fired, however we'd like to take action only when 
                        // the media query change went into effect 
                        if(numOfVisiblePlans !== newNumOfVisiblePlans){
                            this._updateCarouselNavBtnVisibility();
                            numOfVisiblePlans= newNumOfVisiblePlans;
                        }
                    },this));
                },this));
            },
            _updateNumOfEngagements: function(usage){
                this.model.set("engagementUsage", usage);
                
                if( usage > 0 ) {
                    this.ui.numOfEngagements.text(usage);
                    this.ui.engagementsUsageContainer.show();
                }else{
                    this.ui.engagementsUsageContainer.hide();
                }
            },
            /**
             * This is the handler when clicking on the carousel navigation buttons
             * @param event
             * @private
             */
            _onPlansNav: function(event){
                if($(event.currentTarget).hasClass("disabled")){
                    return;
                }
                $(this.ui.plansRowContainer).addClass("noanimation");
                // distinguish which nav button was invoked, prev or next
                var isPrevBtnInvoked= $(event.currentTarget).hasClass("plans-carousel-prev");
                var mode=  $(this.ui.plansView).hasClass("month") ? "month" : $(this.ui.plansView).hasClass("annual") ? "annual" : "quarter";    

                //this.groups[mode].offset= isPrevBtnInvoked ? Math.max(0, --this.groups[mode].offset) : Math.min(this.groups[mode].count, ++this.groups[mode].offset);

                // hide token algorithm: hide-month hide-quarter hide-annual
                var hideClassToken= "hide-" + mode;
                
                //find the index of the first displayed plan
                var indexOfDisplayed= -1;
                var plansEl= this.$el.find('.plans-carousel .plan-box');
                $.each(plansEl, function(index, el){
                    if($(el).css('display') !== "none"){
                        indexOfDisplayed= index;
                        return false;
                    }
                });

                var visibleCount;
                if(isPrevBtnInvoked){
                    var plan,i;
                    //if prev loop through lower indexes till you bump into the first plan on which a hide token was placed
                    //and remove that token
                    for(i=indexOfDisplayed; i > -1; i--){
                        plan= $(plansEl.get(i));
                        if(plan.hasClass(hideClassToken)){
                            plan.removeClass(hideClassToken);
                            break;
                        }
                    }
                }else{
                    //if next put a hide token on the first displayed plan
                    $(plansEl.get(indexOfDisplayed)).addClass(hideClassToken);                    
                }
                
                //handle nav buttons display mode
                this._updateCarouselNavBtnVisibility();
            },
            /**
             * updates the state of enablement of the prev and next buttons
             * as well as the step indicator 
             * @return {[type]} [description]
             */
            _updateCarouselNavBtnVisibility: function(){
                var mode=  $(this.ui.plansView).hasClass("month") ? "month" : $(this.ui.plansView).hasClass("annual") ? "annual" : "quarter";

                // hide the carousel buttons and step indicator:
                // wide viewport case: no more than 3 catalog plans, regardless of personal
                // narrow viewport case: no more than 3 catalog plans, but just if there's no non-catalog personal plan 
                var numOfVisiblePlans= $(this.ui.plansRowContainer).width() > 700 ? 3 : 2;
                var hideCarousel= (numOfVisiblePlans === 3 && this.groups[mode].count < 4) || (this.model.get('parsed.personalMode') !== "personal-not-in-catalog" && this.groups[mode].count < 4);
                this.$el.find('.plans-row-container').toggleClass('hideCarousel', hideCarousel);
                if(hideCarousel){
                    return;
                }

                // a reset state where both buttons are disabled
                this.$el.find('.plans-carousel-next').removeClass('disabled');
                this.$el.find('.plans-carousel-prev').removeClass('disabled');

                var hideClassToken= "hide-" + mode;

                //find the index of the first displayed plan
                var indexOfDisplayed= -1;
                var plansEl= this.$el.find('.plans-carousel .plan-box');
                $.each(plansEl, function(index, el){
                    if($(el).css('display') !== "none"){
                        indexOfDisplayed= index;
                        return false;
                    }
                });

                // hide prev if no hideClassToken left
                var i, plan, visibleCount, visibleOffset= 0;
                for(i=indexOfDisplayed; i > -1; i--){
                    plan= $(plansEl.get(i));
                    if(plan.hasClass(hideClassToken)){
                        visibleOffset++;
                    }
                }
                if(visibleOffset === 0){
                    this.$el.find('.plans-carousel-prev').addClass('disabled');
                }

                //hide next if only 3 plans are displayed, regardless of being invisible
                visibleCount= _.reduce(plansEl, function(memo, el){ 
                    if($(el).css('display') !== "none"){
                        return ++memo;
                    }else{
                        return memo; 
                    }
                }, 0);
                //adjust the view according to whether you can fit 2 or 3 plans in the viewport
                if(visibleCount <= numOfVisiblePlans){
                    this.$el.find('.plans-carousel-next').addClass('disabled');
                    if(visibleCount < numOfVisiblePlans){
                        //if visibleCount is smaller reshow the left most plan
                        for(i=indexOfDisplayed; i > -1; i--){
                            plan= $(plansEl.get(i));
                            if(plan.hasClass(hideClassToken)){
                                plan.removeClass(hideClassToken);
                                --visibleOffset;
                                break;
                            }
                        }
                        //reconsider hiding prev now that you might have fit into view more plans
                        var hidePrev= true;
                        for(i=indexOfDisplayed; i > -1; i--){
                            plan= $(plansEl.get(i));
                            if(plan.hasClass(hideClassToken)){
                                hidePrev= false;
                                break;
                            }
                        }
                        if(hidePrev){
                            this.$el.find('.plans-carousel-prev').addClass('disabled');
                        }
                    }
                }

                renderCarouselStepIndicator(this);


                function renderCarouselStepIndicator(that){
                    var numSteps= that.groups[mode].count;
                    $(that.ui.plansCarouselStepIndicator).html("");
                    for(i=0; i < numSteps; i++){
                        var bullet= $('<div class="step"></div>');
                        if(i >= visibleOffset && i < visibleOffset+numOfVisiblePlans){
                            bullet.addClass("visible");
                        }
                        $(that.ui.plansCarouselStepIndicator).append(bullet);
                    }
                }

            },
            _onSwitchPeriod: function(event){
                var $tab= $(event.currentTarget);

                // do nothing for disabled tabs
                if( this.ui.tabs.parent().hasClass("hasSelectedPlan") && this.ui.tabs.parent().find(".js-current").index() < $tab.index() ){
                    return;
                }
                
                $(this.ui.plansRowContainer).removeClass("noanimation");

                // set selected tab
                this.ui.tabs.removeClass("selected");
                $tab.addClass("selected");

                // filter plans by selected tab period
                var tab= $tab.hasClass("tab-annual") ? "annual" : ($tab.hasClass("tab-quarter") ? "quarter" : "month");
                $(this.ui.plansView).removeClass("annual quarter month");
                $(this.ui.plansView).addClass(tab);    

                this._updateCarouselNavBtnVisibility();

                LERegistration.logger.info("Changed billing cycle tab to " + tab, "PlanSelectionView:_onSwitchPeriod");
            },
            _onChat: function(event){
                LERegistration.logger.info("Chat with us button was clicked","PlanSelectionView:_onChat");
                this.trigger(PlanSelectionView.TRIGGERING.CHAT_BUTTON_CLICKED);
            },
            _onLearnMore: function(event){
                LERegistration.logger.info("Learn more button was clicked","PlanSelectionView:_onLearnMore");
                LE.vent.trigger("openKP", {fragment: "billing-tier-change"});
            },
            _onClosePage: function() {
                LERegistration.logger.info("PlanSelectionView:_onClosePage");
                this.trigger(PlanSelectionView.TRIGGERING.CANCEL_BUTTON_CLICKED);
            },
            stepIndicatorOptions: function(){
                var trial= 
                    [
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step0"), state: StepIndicator.STATE.CURRENT},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step2"), state: StepIndicator.STATE.NOT_COMPLETED},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED}
                    ];
                var paying= 
                    [
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step0"), state: StepIndicator.STATE.CURRENT},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED}
                    ];
                return {
                    el: "view.ui.stepIndicator",
                    steps: this.mode === PlansCollection.MODES.TRIAL ? trial : paying
                };
            }

        });
        
    });

    PlanSelectionView.TRIGGERING= {
        CANCEL_BUTTON_CLICKED: "cancel",
        CHAT_BUTTON_CLICKED: "chat"
    };


    return PlanSelectionView;
});